import { LoopEnvironment } from './model';
import { EnumObjectValue } from '@shared/utils/common/types';

type ApiConfig = Omit<LoopEnvironment, 'isProduction' | 'isUsingProxy' | 'graphicsBaseUrl' | 'name'>;

export const ApiConfigKey = {
  PRODUCTION: 'PRODUCTION',
  SPRINT: 'SPRINT',
  LOOP: 'LOOP',
  STAGE: 'STAGE'
} as const;

export type ApiConfigKeyValue = EnumObjectValue<typeof ApiConfigKey>;

export const API_CONFIGS: Record<ApiConfigKeyValue, ApiConfig> = {
  PRODUCTION: {
    clientId: '641033709772-go9onjsta8f7mraokjrblcijs3394apg.apps.googleusercontent.com',
    microsoftClientId: '0c49d50e-04d5-479d-acd9-640a4d6b3321',
    apiUri: 'https://api.intheloop.io',
    logUri: 'https://log.intheloop.io',
    wsUri: 'https://socket.intheloop.io',
    signUpUrl: 'https://signup.intheloop.io',
    webOnboardingUrl: 'https://register.intheloop.io',
    clientSecret: 'ca32eec4-c030-4fe2-929c-22c18be45dd2',
    commentCacheDurationMinutes: 30
  },
  SPRINT: {
    clientId: '661500301384.apps.googleusercontent.com',
    microsoftClientId: 'f30d45f7-c3cb-4d43-ae53-a4d64ab92bb3',
    apiUri: 'https://sprint.snapp.email',
    logUri: 'https://log-sprint.snapp.email',
    wsUri: 'https://socket-sprint.snapp.email',
    signUpUrl: 'https://signup.snapp.email',
    webOnboardingUrl: 'https://register.snapp.email',
    clientSecret: '50e1ab79-d039-45f5-8297-4485ba47421c',
    commentCacheDurationMinutes: 5
  },
  LOOP: {
    clientId: '661500301384.apps.googleusercontent.com',
    microsoftClientId: 'f30d45f7-c3cb-4d43-ae53-a4d64ab92bb3',
    apiUri: 'https://loop.snapp.email',
    logUri: 'https://log-loop.snapp.email',
    wsUri: 'https://socket-loop.snapp.email',
    signUpUrl: 'https://signup-loop.snapp.email',
    webOnboardingUrl: 'https://register-loop.snapp.email',
    clientSecret: '50e1ab79-d039-45f5-8297-4485ba47421c',
    commentCacheDurationMinutes: 5
  },
  STAGE: {
    clientId: '661500301384.apps.googleusercontent.com',
    microsoftClientId: '4c605c1c-aeb4-45e2-ab15-5e25f2a787ce',
    apiUri: 'https://stage.intheloop.io',
    logUri: 'https://log-stage.intheloop.io',
    wsUri: 'https://socket-stage.intheloop.io',
    signUpUrl: 'https://signup-stage.intheloop.io',
    webOnboardingUrl: 'https://register-stage.intheloop.io',
    clientSecret: 'e3cbd22d-058e-4144-8a18-b0c55bd2227d',
    commentCacheDurationMinutes: 5
  }
};
